// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.wxhealthplan .van-tab {\n  font-size: 42px;\n  color: #333;\n  line-height: 88px;\n}\n.wxhealthplan .van-tabs--line .van-tabs__wrap {\n  height: 88px;\n}\n.wxhealthplan .van-tabs__line {\n  width: 140px;\n}\n", ""]);
// Exports
module.exports = exports;
